
class Header
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Header
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    //スクロールのハンドリング
    $(window).scroll(this.onScroll.bind(this))
    this.onScroll()
  }

  /**
   * スクロール
   */
  onScroll(e)
  {
    const scrollY = $(window).scrollTop()
    const header = $('.sc-header')

    if(scrollY <= 0 && header.hasClass('show'))
    {
      header.removeClass('show')
    }
    else if(scrollY > 0 && !header.hasClass('show'))
    {
      header.addClass('show')
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Header
